import { DmsObjectIcon, dmsObjectIconDirective } from './DmsObjectIcon';
export { DmsObjectIcon, dmsObjectIconDirective };
